<div class="doNotPrint">
  <div class="p-3">
    <div class="group mt-3">
      <input type="number" required class="textInputLong" name="amount" [(ngModel)]="amount" min="0" (keypress)="sharedService.isNumberKey($event)" />
      <span class="highlight"></span>
      <span class="bar barLong"></span>
      <label>Loan Amount</label>
    </div>

    <div class="col-12">
      <p>Loan Date</p>
    </div>
    <div class="col-12">
      <mat-form-field class="full-width-formField p-0">
        <input matInput readonly [matDatepicker]="loanDatePicker" name="date" [(ngModel)]="date" required />
        <mat-datepicker-toggle matSuffix [for]="loanDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #loanDatePicker name="date"></mat-datepicker>
      </mat-form-field>
      <button class="btn btn-danger ms-1" (click)="date = undefined"><i class="fas fa-times"></i></button>
    </div>
    <div class="col-12">
      <p>Form J Date</p>
    </div>
    <div class="col-12">
      <mat-form-field class="full-width-formField p-0">
        <input matInput readonly [matDatepicker]="formJDatePicker" name="formJDate" [(ngModel)]="formJDate" required />
        <mat-datepicker-toggle matSuffix [for]="formJDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #formJDatePicker name="formJDate"></mat-datepicker>
      </mat-form-field>
      <button class="btn btn-danger ms-1" (click)="formJDate = undefined"><i class="fas fa-times"></i></button>
    </div>
    <hr />
  </div>
</div>
@if (selectedCustomer != undefined && selectedCompany != undefined) {
  <div class="text-justify guarantorForm print-area" style="font-family: &quot;Calibri, sans-serif&quot;; line-height: 120%; font-size: 12pt" id="htmlData" #htmlData>
    <h4 class="text-center">
      <strong> {{ selectedCompany.Name }}</strong>
    </h4>
    <div class="text-center">
      <strong> ({{ selectedCompany.RegNum }})</strong>
    </div>
    <div class="text-center">
      <strong> {{ selectedCompany.Address }}</strong>
    </div>
    <div class="text-center">
      <strong> TEL: {{ selectedCompany.ContactNo }}</strong>
    </div>
    <br />
    <p class="d-flex justify-content-end pe-5">
      Tarikh :
      <strong>
        @if (date != undefined) {
          <span> {{ date | date: "dd/MM/yyyy" }}</span>
        }
      </strong>
      @if (date == undefined) {
        <span>______________</span>
      }
    </p>
    <h6 class="text-center text-decoration-underline"><strong>SURAT JAMINAN PERIBADI</strong></h6>
    <br />
    <p>
      JAMINAN ini adalah antara “PEMBERI PINJAMAN” {{ selectedCompany.Name }} dengan “PENJAMIN” atas Perjanjian Pinjaman Wang (Form J) bertarikh
      <strong>
        @if (formJDate != undefined) {
          <span
            ><u>{{ formJDate | date: "dd/MM/yyyy" }}</u></span
          >
        }
        @if (formJDate == undefined) {
          <span>_______________________</span>
        }
      </strong>
      yang berjumlah
      <strong>
        RM
        @if (amount != 0 && amount != undefined) {
          <span
            ><u>{{ amount | number: "1.2-2" }}</u></span
          >
        }
        @if (amount == undefined) {
          <span>_______________________</span>
        }
      </strong>
      antara Pemberi Pinjaman dengan “PEMINJAM”:
    </p>
    <br />
    <table class="fw-bold" style="border: none">
      <tr>
        <td>NAMA</td>
        <td>:</td>
        <td class="p-2">{{ selectedCustomer.Name }}</td>
      </tr>
      <tr>
        <td>NO. I.C.</td>
        <td>:</td>
        <td class="p-2">{{ selectedCustomer.ICNumberWithDash }}</td>
      </tr>
    </table>
    <br />
    <p>Sekiranya Peminjam gagal untuk membuat pembayaran penuh semasa umur {{ epfSettlementAge }} tahun ataupun mempunyai hutang tertunggak selepas umur {{ epfSettlementAge }} tahun, Penjamin akan mengambil tanggungjawab untuk melangsaikan hutang tertunggak sebagaimana yang patut dibayar oleh Peminjam.</p>
    <p><strong>Nota: Jumlah pembayaran balik adalah muktamad dan sebarang diskaun atas pembayaran balik pinjaman adalah tidak dibenarkan.</strong></p>
    <p>
      Pemberi Pinjaman juga diberikan kuasa untuk <strong>menyenarai hitamkan nama Penjamin dalam Sistem CTOS</strong>
      sekiranya Peminjam gagal untuk membuat pembayaran penuh ataupun mempunyai hutang tertunggak semasa umur
      {{ epfSettlementAge }} tahun.
    </p>
    <p>Saya memberi jaminan bahawa Peminjam akan membuat pembayaran pinjaman dalam masa yang sepatutnya dan seperti yang dinyatakan di atas Perjanjian Pinjaman Wang. (Form J)</p>
    <br />
    @if (contact != undefined) {
      <table style="border: none">
        <tr>
          <td>Tandatangan PENJAMIN</td>
          <td>:</td>
          <td></td>
        </tr>
        <tr>
          <td>Nama</td>
          <td>:</td>
          <td class="p-2">{{ contact.Name }}</td>
        </tr>
        <tr>
          <td>No. K.P.</td>
          <td>:</td>
          @if (contact.ICNumber != undefined) {
            <td class="p-2">{{ sharedService.processICNum(contact.ICNumber) }}</td>
          }
        </tr>
        <tr>
          <td>No. Tel.</td>
          <td>:</td>
          <td class="p-2">{{ contact.ContactNumber }}</td>
        </tr>
      </table>
    }
    <br />
    <table style="border: none">
      <tr>
        <td>Tandatangan PEMINJAM</td>
        <td>:</td>
        <td></td>
      </tr>
      <tr>
        <td>Nama</td>
        <td>:</td>
        <td class="p-2">{{ selectedCustomer.Name }}</td>
      </tr>
      <tr>
        <td>No. K.P.</td>
        <td>:</td>
        @if (selectedCustomer.ICNumber != undefined) {
          <td class="p-2">
            {{ selectedCustomer.ICNumberWithDash }}
          </td>
        }
      </tr>
      <tr>
        <td>No. Tel.</td>
        <td>:</td>
        <td class="p-2">{{ selectedCustomer.ContactNo }}</td>
      </tr>
    </table>
  </div>
}
